import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import CoachingKangaroo from '../../../../api/CoachingKangaroo';
import FormControl from '@material-ui/core/FormControl';
import useAlert from '../../../hooks/useAlert';
import { isTrainer } from '../../../../services/authService';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  smallText: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightRegular
  },
  iconContainer: {
    fontSize: theme.typography.pxToRem(12)
  },
  formControl: {
    minWidth: '50%',
    maxWidth: '50%'
  }
}));

const ConversationItemComments = (props) => {
  const classes = useStyles();
  const [originalCommentText, setOriginalCommentText] = useState('');
  const [commentText, setCommentText] = useState('');
  const [commentSaved, setCommentSaved] = useState(true);
  const [savingInProgress, setSavingInProgress] = useState(false);
  const { Alert, status, showError } = useAlert();
  const { t } = useTranslation();

  useEffect(() => {
    if (props.comments && props.comments.length > 0) {
      setOriginalCommentText(props.comments[props.comments.length - 1].text);
      setCommentText(props.comments[props.comments.length - 1].text);
    }
  }, [props.comments]);

  const changeInputValue = (event) => {
    setCommentText(event.currentTarget.value);
    if (originalCommentText === event.currentTarget.value) {
      setCommentSaved(true);
    } else {
      setCommentSaved(false);
    }
  };

  const saveComment = (textToSave) => {
    if (textToSave === originalCommentText) {
      return;
    }

    setSavingInProgress(true);

    let requestBody = { comment: textToSave };

    CoachingKangaroo.put(
      '/api/training/v1/' +
        encodeURIComponent(props.project) +
        '/conversation/' +
        props.conversationId +
        '/answer/' +
        props.answerId,
      JSON.stringify(requestBody)
    )
      .catch((error) => {
        showError(error);
      })
      .finally(() => {
        setOriginalCommentText(textToSave);
        setCommentSaved(true);
        setSavingInProgress(false);
      });
  };

  const handleBlur = () => {
    if (!commentSaved && commentText !== originalCommentText) {
      saveComment(commentText);
    }
  };

  return (
    <React.Fragment>
      {status ? <Alert /> : null}
      <Grid
        container
        justify="flex-end"
        alignItems="flex-end"
        style={{ marginTop: '1em' }}
      >
        <Grid item style={{ width: '50%' }}>
          <FormControl
            onClick={() =>
              isTrainer(props.project)
                ? undefined
                : showError(
                    'You do not have enough permissions to edit conversations.'
                  )
            }
            className={classes.formControl}
          >
            <TextField
              label={commentText ? (commentSaved ? '  ' : '') : t('Add new Comment')}
              value={commentText}
              onChange={changeInputValue}
              onBlur={handleBlur}
              disabled={savingInProgress}
              multiline
              minRows={1}
              maxRows={10}
              fullWidth
              {...(!isTrainer(props.project) && { disabled: true })}
              InputProps={{
                style: { fontSize: 12, wordWrap: 'break-word', whiteSpace: 'pre-wrap' }
              }}
              InputLabelProps={{ style: { fontSize: 12 } }}
            />
            {commentText && !commentSaved && (
              <Typography variant="caption" style={{ color: '#000', fontSize: 12, marginTop: '4px' }}>
                {t('Comment will be saved automatically')}
              </Typography>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default ConversationItemComments;
